// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar__navigation button {
  color: #6f48eb;
  min-width: 44px;
  background: none;
  font-size: 16px;
  margin-top: 8px;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #f8f8fa;
}
.react-calendar__navigation button[disabled] {
  background-color: #f0f0f0;
}
abbr[title] {
  text-decoration: none;
}
.holiday {
  color: #fff;
  background-color: #44986f;
}

.react-calendar__month-view__days__day--weekend {
  color: #6f48eb;
  background-color: #d9d9d9;
}
.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background: #eeeeee;
  color: #6f48eb;
  border-radius: 0px;
}
.react-calendar__tile--now {
  background: #6f48eb33;
  border-radius: 0px;
  font-weight: bold;
  color: #6f48eb;
}
.react-calendar__tile--now:enabled:hover,
.react-calendar__tile--now:enabled:focus {
  background: #6f48eb33;
  border-radius: 0px;
  font-weight: bold;
  color: #6f48eb;
}
.react-calendar__tile--hasActive:enabled:hover,
.react-calendar__tile--hasActive:enabled:focus {
  background: #f8f8fa;
}
.react-calendar__tile--active {
  background: #6f48eb;
  border-radius: 6px;
  font-weight: bold;
  color: white;
}
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: #6f48eb;
  color: white;
}
.react-calendar--selectRange .react-calendar__tile--hover {
  /* background-color: #f8f8fa; */
  background: #6f48eb;
  color: white;
}
.react-calendar__tile--range {
  background: #f8f8fa;
  color: #6f48eb;
  border-radius: 0;
}
.react-calendar__tile--rangeStart {
  /* border-top-right-radius: 0;
  border-bottom-right-radius: 0; */
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: #6f48eb;
  color: white;
}
.react-calendar__tile--rangeEnd {
  border-radius: 0px;
  background: #6f48eb;
  color: white;
}

.react-calendar__navigation button {
  color: #ffffff;
  min-width: 44px;
  background-color: #6f48eb;
  font-size: 16px;
  margin-top: 0px;
  border: 0px !important;
}
.react-calendar {
  max-width: 100%;
  max-width: 100%;
  width: 100%;
  /* background-color: #fff; */
  color: #222;
  border-radius: 0px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
}
.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
  background-color: #3ca8e8;
}

.react-calendar button {
  font-weight: bold;
  border: 1px solid #e9e9e9;
}
.react-calendar__navigation {
  margin-bottom: 0px;
}
.react-calendar__month-view__weekdays {
  border-top: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
}
.react-calendar__month-view .react-calendar__month-view__weekdays__weekday {
  border: 1px solid #e9e9e9;
}

/* For regular Saturdays */
.react-calendar__month-view__days__day--weekend.holiday {
  color: #6f48eb;
  background-color: #d9d9d9;
}

/* For the first four Saturdays of each month */
.react-calendar__month-view__days__day--weekend.first-four-saturdays-holiday {
  color: #ffffff; /* Text color for holidays */
  background-color: #ff0000; /* Background color for holidays */
}
.last-saturday {
  /* Style for the last Saturday of each month */
  background-color: #3ca8e8; /* Adjust the color as needed */
}
.holiday-tooltip {
  cursor: pointer; /* Show cursor as pointer when hovering */
}
.react-calendar__tile:disabled {
  /* background-color: #f0f0f0; */
}
.react-calendar__month-view__weekdays__weekday abbr {
  text-decoration: none;
  display: block !important;
  visibility: visible !important;
  font-weight: 600;
  color: #333;
}

.react-calendar__month-view__weekdays__weekday {
  text-align: center;
  padding: 8px 0;
  display: flex !important;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Workdesk.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;kCACgC;EAChC,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB;AACtB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,cAAc,EAAE,4BAA4B;EAC5C,yBAAyB,EAAE,kCAAkC;AAC/D;AACA;EACE,8CAA8C;EAC9C,yBAAyB,EAAE,+BAA+B;AAC5D;AACA;EACE,eAAe,EAAE,yCAAyC;AAC5D;AACA;EACE,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".react-calendar__navigation button {\r\n  color: #6f48eb;\r\n  min-width: 44px;\r\n  background: none;\r\n  font-size: 16px;\r\n  margin-top: 8px;\r\n}\r\n.react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background-color: #f8f8fa;\r\n}\r\n.react-calendar__navigation button[disabled] {\r\n  background-color: #f0f0f0;\r\n}\r\nabbr[title] {\r\n  text-decoration: none;\r\n}\r\n.holiday {\r\n  color: #fff;\r\n  background-color: #44986f;\r\n}\r\n\r\n.react-calendar__month-view__days__day--weekend {\r\n  color: #6f48eb;\r\n  background-color: #d9d9d9;\r\n}\r\n.react-calendar__tile:enabled:hover,\r\n.react-calendar__tile:enabled:focus {\r\n  background: #eeeeee;\r\n  color: #6f48eb;\r\n  border-radius: 0px;\r\n}\r\n.react-calendar__tile--now {\r\n  background: #6f48eb33;\r\n  border-radius: 0px;\r\n  font-weight: bold;\r\n  color: #6f48eb;\r\n}\r\n.react-calendar__tile--now:enabled:hover,\r\n.react-calendar__tile--now:enabled:focus {\r\n  background: #6f48eb33;\r\n  border-radius: 0px;\r\n  font-weight: bold;\r\n  color: #6f48eb;\r\n}\r\n.react-calendar__tile--hasActive:enabled:hover,\r\n.react-calendar__tile--hasActive:enabled:focus {\r\n  background: #f8f8fa;\r\n}\r\n.react-calendar__tile--active {\r\n  background: #6f48eb;\r\n  border-radius: 6px;\r\n  font-weight: bold;\r\n  color: white;\r\n}\r\n.react-calendar__tile--active:enabled:hover,\r\n.react-calendar__tile--active:enabled:focus {\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n.react-calendar--selectRange .react-calendar__tile--hover {\r\n  /* background-color: #f8f8fa; */\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n.react-calendar__tile--range {\r\n  background: #f8f8fa;\r\n  color: #6f48eb;\r\n  border-radius: 0;\r\n}\r\n.react-calendar__tile--rangeStart {\r\n  /* border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0; */\r\n  border-top-left-radius: 6px;\r\n  border-bottom-left-radius: 6px;\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n.react-calendar__tile--rangeEnd {\r\n  border-radius: 0px;\r\n  background: #6f48eb;\r\n  color: white;\r\n}\r\n\r\n.react-calendar__navigation button {\r\n  color: #ffffff;\r\n  min-width: 44px;\r\n  background-color: #6f48eb;\r\n  font-size: 16px;\r\n  margin-top: 0px;\r\n  border: 0px !important;\r\n}\r\n.react-calendar {\r\n  max-width: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  /* background-color: #fff; */\r\n  color: #222;\r\n  border-radius: 0px;\r\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  line-height: 1.125em;\r\n}\r\n.react-calendar__navigation button:enabled:hover,\r\n.react-calendar__navigation button:enabled:focus {\r\n  background-color: #3ca8e8;\r\n}\r\n\r\n.react-calendar button {\r\n  font-weight: bold;\r\n  border: 1px solid #e9e9e9;\r\n}\r\n.react-calendar__navigation {\r\n  margin-bottom: 0px;\r\n}\r\n.react-calendar__month-view__weekdays {\r\n  border-top: 1px solid #e9e9e9;\r\n  border-bottom: 1px solid #e9e9e9;\r\n}\r\n.react-calendar__month-view .react-calendar__month-view__weekdays__weekday {\r\n  border: 1px solid #e9e9e9;\r\n}\r\n\r\n/* For regular Saturdays */\r\n.react-calendar__month-view__days__day--weekend.holiday {\r\n  color: #6f48eb;\r\n  background-color: #d9d9d9;\r\n}\r\n\r\n/* For the first four Saturdays of each month */\r\n.react-calendar__month-view__days__day--weekend.first-four-saturdays-holiday {\r\n  color: #ffffff; /* Text color for holidays */\r\n  background-color: #ff0000; /* Background color for holidays */\r\n}\r\n.last-saturday {\r\n  /* Style for the last Saturday of each month */\r\n  background-color: #3ca8e8; /* Adjust the color as needed */\r\n}\r\n.holiday-tooltip {\r\n  cursor: pointer; /* Show cursor as pointer when hovering */\r\n}\r\n.react-calendar__tile:disabled {\r\n  /* background-color: #f0f0f0; */\r\n}\r\n.react-calendar__month-view__weekdays__weekday abbr {\r\n  text-decoration: none;\r\n  display: block !important;\r\n  visibility: visible !important;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.react-calendar__month-view__weekdays__weekday {\r\n  text-align: center;\r\n  padding: 8px 0;\r\n  display: flex !important;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
